/* The Fragrance Room collection page: in-place filtering of server-rendered product cards.
   Choices within one filter match any; different filters narrow together. State lives in the URL
   (?category=candles&size=mini&style=lid&brand=the-grand) so menu links and shared links pre-select filters.
   Shopify reserves ?format, so the category filter uses ?category. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tfr-collection]');
  if (!root) return;

  var L = {
    category: { candles: 'Candles', diffusers: 'Reed diffusers', car: 'Car diffusers', oils: 'Fragrance oils', refills: 'Refills', sprays: 'Room & linen sprays', body: 'Bath & body', hair: 'Hair care', perfume: 'Perfume', gifts: 'Gift sets', other: 'Other' },
    size: { mini: 'Mini', classic: 'Classic', grand: 'Grand', large: 'Large', '50ml': '50ml', '100ml': '100ml', '200ml': '200ml', '500ml': '500ml' },
    style: { unboxed: 'Unboxed', lid: 'With lid', combo: 'Diffuser & refill combo' },
    mood: { 'fresh-bright': 'Fresh & bright', 'warm-cosy': 'Warm & cosy', 'green-earthy': 'Green & earthy', 'rich-enveloping': 'Rich & enveloping' },
    family: { citrus: 'Citrus', floral: 'Floral', green: 'Green & aromatic', woody: 'Woody', sweet: 'Sweet & gourmand', spiced: 'Spiced' },
    price: { 'under-300': 'Under R300', '300-500': 'R300 to R500', '500-1000': 'R500 to R1,000', 'over-1000': 'R1,000 and up' },
    scent: { celebration: 'Celebration', 'pink-sapphire': 'Pink Sapphire', 'celebration-home': 'Celebration', 'celebration-perfume': 'Celebration' }
  };
  var GROUPS = [
    { key: 'category', title: 'Category', multi: false },
    { key: 'size', title: 'Size' },
    { key: 'style', title: 'Style', multi: true },
    { key: 'occasion', title: 'Occasion' },
    { key: 'scent', title: 'Scent' },
    { key: 'mood', title: 'Mood', multi: true, note: 'Moods and families come from each fragrance’s published notes.' },
    { key: 'family', title: 'Fragrance family', multi: true },
    { key: 'brand', title: 'Fragrance house' },
    { key: 'price', title: 'Price' },
    { key: 'instock', title: 'Availability' }
  ];
  var ORDER = { size: ['mini', 'classic', 'grand', 'large', '50ml', '100ml', '200ml', '500ml'], style: ['unboxed', 'lid', 'combo'], price: ['under-300', '300-500', '500-1000', 'over-1000'], category: ['candles', 'diffusers', 'car', 'oils', 'refills', 'sprays', 'body', 'hair', 'perfume', 'gifts', 'other'] };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function priceBand(c) { var r = c / 100; return r < 300 ? 'under-300' : r < 500 ? '300-500' : r < 1000 ? '500-1000' : 'over-1000'; }

  var grid = root.querySelector('[data-grid]');
  var items = Array.prototype.slice.call(grid.querySelectorAll('.cc-item')).map(function (el) {
    var d = el.dataset;
    return {
      el: el, i: +d.i, a: d.available === '1',
      v: {
        category: d.format ? [d.format] : [], size: d.size ? [d.size] : [], style: d.style ? d.style.trim().split(/\s+/) : [], scent: d.scent ? [d.scent] : [],
        occasion: d.occasion ? d.occasion.trim().split(/\s+/) : [], mood: d.mood ? d.mood.split(' ') : [], family: d.family ? d.family.split(' ') : [],
        brand: d.brand ? [d.brand] : [], price: [priceBand(+d.price)], instock: d.available === '1' ? ['1'] : []
      },
      names: { scent: d.scentName, brand: d.brandName }
    };
  });
  /* sold-out products sink to the end, otherwise keep the server's sort order */
  items.sort(function (a, b) { return (b.a - a.a) || (a.i - b.i); });
  items.forEach(function (it) { grid.appendChild(it.el); });

  var names = { scent: {}, brand: {} };
  items.forEach(function (it) { ['scent', 'brand'].forEach(function (k) { if (it.v[k][0] && it.names[k]) names[k][it.v[k][0]] = it.names[k]; }); });
  function label(k, v) {
    if (k === 'instock') return 'In stock only';
    if (k === 'occasion') return v.charAt(0).toUpperCase() + v.slice(1).replace(/-/g, ' ');
    return (L[k] && L[k][v]) || names[k] && names[k][v] || v;
  }

  var sel = {};
  GROUPS.forEach(function (g) { sel[g.key] = []; });
  var params = new URLSearchParams(location.search);
  GROUPS.forEach(function (g) { var p = params.get(g.key); if (p) sel[g.key] = p.split(',').filter(Boolean); });

  var size = parseInt(root.dataset.pageSize || '24', 10), shown = size;
  var facetsEl = root.querySelector('[data-facets]'), chips = root.querySelector('[data-chips]');
  var countEl = root.querySelector('[data-count]'), more = root.querySelector('[data-more]'), moreStatus = root.querySelector('[data-more-status]');
  var empty = root.querySelector('[data-empty]'), activeN = root.querySelector('[data-active-n]');
  var drawer = root.querySelector('[data-drawer]');

  function passes(it, except) {
    for (var gi = 0; gi < GROUPS.length; gi++) {
      var k = GROUPS[gi].key;
      if (k === except || !sel[k].length) continue;
      var ok = false;
      for (var j = 0; j < sel[k].length; j++) if (it.v[k].indexOf(sel[k][j]) > -1) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }

  function buildFacets() {
    var html = '';
    GROUPS.forEach(function (g) {
      var counts = {}, all = {};
      items.forEach(function (it) {
        it.v[g.key].forEach(function (v) { all[v] = 1; });
        if (!passes(it, g.key)) return;
        it.v[g.key].forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      });
      var vals = Object.keys(all);
      if (g.key === 'instock') { if (!items.some(function (it) { return !it.a; })) return; }
      else if (g.key === 'style') { if (!vals.length) return; } /* one style (e.g. 'With lid' on candles) is still a useful choice */
      else if (vals.length < 2 && !sel[g.key].length) return;
      if (ORDER[g.key]) vals.sort(function (a, b) { return ORDER[g.key].indexOf(a) - ORDER[g.key].indexOf(b); });
      else vals.sort(function (a, b) { return label(g.key, a).localeCompare(label(g.key, b)); });
      var open = sel[g.key].length || g.key === 'category' || g.key === 'scent';
      html += '<details class="cc-facet"' + (open ? ' open' : '') + '><summary>' + esc(g.title) + (sel[g.key].length ? ' <span class="cc-facet__n">(' + sel[g.key].length + ')</span>' : '') + '</summary><div class="cc-facet__opts">';
      if (g.note) html += '<p class="cc-facet__note">' + esc(g.note) + '</p>';
      vals.forEach(function (v) {
        var n = counts[v] || 0, on = sel[g.key].indexOf(v) > -1;
        html += '<label class="cc-opt' + (n === 0 && !on ? ' is-zero' : '') + '"><input type="checkbox" data-k="' + g.key + '" value="' + esc(v) + '"' + (on ? ' checked' : '') + (n === 0 && !on ? ' disabled' : '') + '><span class="cc-opt__box" aria-hidden="true"></span><span class="cc-opt__label">' + esc(label(g.key, v)) + '</span><span class="cc-opt__n">' + n + '</span></label>';
      });
      html += '</div></details>';
    });
    var openNow = Array.prototype.map.call(facetsEl.querySelectorAll('details[open] summary'), function (s) { return s.textContent.replace(/\s*\(\d+\)$/, ''); });
    facetsEl.innerHTML = html;
    if (openNow.length) facetsEl.querySelectorAll('details').forEach(function (d) { var t = d.querySelector('summary').textContent.replace(/\s*\(\d+\)$/, ''); if (openNow.indexOf(t) > -1) d.open = true; });
  }

  function render(fromUser) {
    var list = items.filter(function (it) { return passes(it); });
    items.forEach(function (it) { it.el.hidden = true; });
    list.forEach(function (it, n) { it.el.hidden = n >= shown; });
    var total = list.length;
    countEl.textContent = total + (total === 1 ? ' product' : ' products');
    empty.hidden = total > 0 || !items.length;
    more.hidden = total <= shown;
    moreStatus.textContent = total > 0 ? 'Showing ' + Math.min(shown, total) + ' of ' + total : '';

    var picked = [];
    GROUPS.forEach(function (g) { sel[g.key].forEach(function (v) { picked.push([g.key, v]); }); });
    activeN.hidden = !picked.length; activeN.textContent = picked.length;
    if (picked.length) {
      chips.hidden = false;
      chips.innerHTML = picked.map(function (kv) { return '<button type="button" class="v2-chip" data-remove="' + kv[0] + '|' + esc(kv[1]) + '">' + esc(label(kv[0], kv[1])) + ' <span aria-hidden="true">×</span><span class="visually-hidden">, remove filter</span></button>'; }).join('') + '<button type="button" class="v2-chip v2-chip--clear" data-clear>Clear all</button>';
    } else { chips.hidden = true; chips.innerHTML = ''; }
    if (!total && picked.length) {
      var last = picked[picked.length - 1];
      empty.querySelector('[data-empty-hint]').innerHTML = 'Try removing <button type="button" class="v2-textbtn" data-remove="' + last[0] + '|' + esc(last[1]) + '">' + esc(label(last[0], last[1])) + '</button> or <button type="button" class="v2-textbtn" data-clear>clear all filters</button>.';
    }
    root.querySelector('[data-apply]').textContent = 'Show ' + total + (total === 1 ? ' product' : ' products');
    buildFacets();
    if (fromUser) {
      var u = new URL(location.href);
      GROUPS.forEach(function (g) { if (sel[g.key].length) u.searchParams.set(g.key, sel[g.key].join(',')); else u.searchParams.delete(g.key); });
      u.searchParams.delete('page');
      history.replaceState(null, '', u.toString());
    }
  }

  function toggle(k, v, on) {
    var a = sel[k], i = a.indexOf(v);
    if (on && i === -1) a.push(v);
    if (!on && i > -1) a.splice(i, 1);
    shown = size; render(true);
  }

  facetsEl.addEventListener('change', function (e) { var t = e.target; if (t.dataset.k) toggle(t.dataset.k, t.value, t.checked); });
  root.addEventListener('click', function (e) {
    var r = e.target.closest('[data-remove]');
    if (r) { var kv = r.dataset.remove.split('|'); toggle(kv[0], kv[1], false); return; }
    if (e.target.closest('[data-clear]')) { GROUPS.forEach(function (g) { sel[g.key] = []; }); shown = size; render(true); return; }
    if (e.target.closest('[data-open-filters]')) { if (drawer.showModal) drawer.showModal(); else drawer.setAttribute('open', ''); return; }
    if (e.target.closest('[data-close-filters]')) { if (drawer.close) drawer.close(); else drawer.removeAttribute('open'); }
  });
  drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
  more.addEventListener('click', function () { shown += size; render(false); var next = items.filter(function (it) { return passes(it); })[shown - size]; if (next) { var a = next.el.querySelector('.tc__title a, .dp__title a'); if (a) a.focus({ preventScroll: true }); } });

  var sortSel = root.querySelector('[data-sort]');
  sortSel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* sticky toolbar shadow */
  var bar = root.querySelector('[data-toolbar]');
  if ('IntersectionObserver' in window) {
    var s = document.createElement('div'); s.style.height = '1px'; bar.parentNode.insertBefore(s, bar);
    new IntersectionObserver(function (en) { bar.classList.toggle('is-stuck', !en[0].isIntersecting); }).observe(s);
  }

  render(false);
})();
